import {DownloadMode} from 'common/report/constants';
import {getDownloadMode, isDigestMode, isTvMode} from 'common/report/util';
import {createElem} from 'common/util/dom';

let initialized = false;
const MUTINY_SCRIPT_SRC = `https://client-registry.mutinycdn.com/personalize/client/94c8846d87697aae.js`;

export async function initMutiny() {
  if (getDownloadMode() !== DownloadMode.None || isDigestMode() || isTvMode() || !window.gdprData || initialized) {
    initialized = true;
    return;
  }

  const gdprData = window.gdprData;
  if (!gdprData.isReady) {
    await gdprData.waitUntilReady();
  }

  if (!gdprData.allowSnippets || !gdprData.allowTracking) {
    initialized = true;
    return;
  }

  if (!document.head.querySelector(`script[src='${MUTINY_SCRIPT_SRC}']`)) {
    const script = document.createElement(`script`);
    script.type = `text/javascript`;
    script.text = `
      (function(){var a=window.mutiny=window.mutiny||{};if(!window.mutiny.client){a.client={_queue:{}};var b=["identify","trackConversion"];var c=[].concat(b,["defaultOptOut","optOut","optIn"]);var d=function factory(c){return function(){for(var d=arguments.length,e=new Array(d),f=0;f<d;f++){e[f]=arguments[f]}a.client._queue[c]=a.client._queue[c]||[];if(b.includes(c)){return new Promise(function(b,d){a.client._queue[c].push({args:e,resolve:b,reject:d})})}else{a.client._queue[c].push({args:e})}}};c.forEach(function(b){a.client[b]=d(b)})}})();
    `;
    document.head.appendChild(script);
    document.head.appendChild(
      createElem(`script`, {
        src: MUTINY_SCRIPT_SRC,
        'data-cfasync': `false`,
        async: true,
        defer: true,
        type: `text/javascript`,
      }),
    );
  }

  initialized = true;
}

export function optOutMutiny() {
  // @ts-ignore
  if (window.mutiny) {
    // @ts-ignore
    window.mutiny.client?.optOut();
  }
}

export function optInMutiny() {
  // @ts-ignore
  if (window.mutiny) {
    // @ts-ignore
    window.mutiny.client?.optIn();
  }
}
